import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookiesService } from 'src/app/cookies.service';
import {
  API_LOGIN,
  USER_TOKEN,
  USER_DATA,
  API_USER,
  API_USER_INFO,
  API_USER_PERSONAL_INFO,
  API_ARTISTS,
  API_USER_PERSONAL_PROFILE,
  API_USER_MAILING_PREFERENCES,
  API_USER_SENSITIVE_CONTENT,
  ARTIST_INFO,
  API_CONTRACT,
  API_SIGNED,
  API_ACCOUNT,
  API_SUBSCRIPTIONS,
  API_BILLING,
  API_INVOICES,
  API_VERIFY,
  API_RECEIPTS,
  API_PROMOTIONS,
  API_URLv2,
  USER_INFO
} from '../../../shared/constants';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  logoutClicked = new BehaviorSubject<boolean>(false);
  callLogout = new BehaviorSubject<boolean>(false);
  changesHasBeenMade = new BehaviorSubject<boolean>(false);
  refreshUserInfo = new BehaviorSubject<boolean>(false);
  refreshUserInfoInHeader = new BehaviorSubject<boolean>(false);
  loadingSection = new BehaviorSubject<boolean>(false);
  updateEmailVerification = new BehaviorSubject<boolean>(false);
  private API_URL: any;

  constructor(private http: HttpClient) {
    this.API_URL = environment.apiUrlv2;
  }

  ngOnDestroy() {
    console.log('DESTROYED',);
  }

  getProfile(id: string, isArtist: boolean): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${isArtist ? API_ARTISTS : API_USER}/${id}${API_USER_PERSONAL_PROFILE}`, httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  updateProfile(id: string, body: any, images: File[], isArtist: boolean): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          // 'Content-Type': 'application/json',
          // 'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      const formData = new FormData();
      if (images.length > 0) {
        for (let i = 0; i < images.length; i++) {
          formData.append('image', images[i], images[i].name);
        }
      }
      formData.append('publicName', body.publicName)
      if (isArtist) {
        formData.append('about', body.about)
        formData.append('shortBiography', body.shortBiography)
        formData.append('headLine', body.headLine)
        for (let i = 0; i < body.socialNetworks.length; i++) {
          if ((body.socialNetworks[i].url || '').trim() !== '') {
            formData.append('socialNetworks[' + i + '].id', body.socialNetworks[i].id || undefined);
            formData.append('socialNetworks[' + i + '].url', body.socialNetworks[i].url || undefined);
          }
        }
      }
      // console.log(formData, images);
      this.http.patch(`${this.API_URL}${isArtist ? API_ARTISTS : API_USER}/${id}${API_USER_PERSONAL_PROFILE}`, formData, httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getPersonalInfo(id: string, isArtist: boolean): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${isArtist ? API_ARTISTS : API_USER}/${id}${API_USER_PERSONAL_INFO}`, httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  updatePersonalInfo(id: string, body: any, isArtist: boolean): Observable<any> {
    try {
      if (body.phones != null) {
        if ((body.phones || []).length !== 0) {
          for (let i = body.phones.length - 1; i != -1; i--) {
            if (body.phones[i].number >= 9223372036854775807) {
              body.phones.splice(i, 1);
            }
          }
        } else {
          body.phones = [];
        }
      }
    } catch (err) { }
    console.log(id, isArtist);
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.patch(`${this.API_URL}${isArtist ? API_ARTISTS : API_USER}/${id}${API_USER_PERSONAL_INFO}`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getMailingPreferences(id: string): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_USER}/${id}${API_USER_MAILING_PREFERENCES}`, httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  updateMailingPreferences(id: string, body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.patch(`${this.API_URL}${API_USER}/${id}${API_USER_MAILING_PREFERENCES}`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getSensitiveContent(id: string): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_USER}/${id}${API_USER_SENSITIVE_CONTENT}`, httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  updateSensitiveContent(id: string, body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.patch(`${this.API_URL}${API_USER}/${id}${API_USER_SENSITIVE_CONTENT}`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getAgreement(id: string): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        }), responseType: 'blob'
      };

      this.http.get(`${this.API_URL}${API_ARTISTS}/${id}${API_CONTRACT}${API_SIGNED}`, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getAgreementDate(id: string): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_ARTISTS}/${id}${API_CONTRACT}`, httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getAccountDetails(id: string): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_USER}/${id}${API_ACCOUNT}`, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getSubscriptions(): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      this.http.get(`${this.API_URL}${API_SUBSCRIPTIONS}`, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getReceipts(userId: number): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_USER}/${userId}${API_RECEIPTS}`, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  setUserAccountAsFree(userId: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };
      const body = {};
      this.http.post(`${this.API_URL}${API_USER}/${userId}${API_ACCOUNT}/free`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  checkUpgradePlan(userId: any, body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };
      this.http.post(`${this.API_URL}${API_USER}/${userId}/checkUpgradePlan`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  setUserPaymentInfo(userId: any, body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };
      this.http.post(`${this.API_URL}${API_USER}/${userId}${API_ACCOUNT}/paymentInfo/card`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  reactivateAccount(userId: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };
      const body = {};
      this.http.post(`${this.API_URL}${API_USER}/${userId}${API_ACCOUNT}/reactivate`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  /**
   * Gets the artist billing details.
   * @param id ID del Artista
   */
  getBillingDetails(id: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_ARTISTS}/${id}${API_BILLING}`, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  /**
   * Updates the artist billing details.
   * @param id ID del Artista
   * @param body {
                  "bankAccount": "string",
                  "bicCode": "string",
                  "country": 0,
                  "iban": true,
                  "ibanNumber": "string",
                  "registeredAddress": "string",
                  "registeredName": "string",
                  "vatID": "string",
                  "zipCode": "string"
                }

      ibanNumber, bankAccount: Just one of them is informed
      country: Id of country (got from /countries service)
      zipCode: Required just for Spain
   */
  updateBillingDetails(id: any, body: any): Observable<any> {
    if (body.bankAccount != null) {
      body.bankAccount += '';
    }
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.patch(`${this.API_URL}${API_ARTISTS}/${id}${API_BILLING}`, JSON.stringify(body), <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  /**
   * Gets the artist invoices.
   * @param id ID del Artista
   */
  getArtistInvoices(id: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_ARTISTS}/${id}${API_INVOICES}`, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  /**
   * Verifies the Bank account (just IBAN accounts, for rest of bank accounts it will return 400).
   * @param id ID del Artista
   * @param body {
                    "bank": "string" (Bank account)
                    "iban": boolean (Indicates if the bank param is an IBAN bank account)
                  }
   */
  postVerifyBank(body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.post(`${this.API_URL}${API_ARTISTS}${API_VERIFY}/bank`, JSON.stringify(body), <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  /**
   * Verifies the SWIFT/BIC code.
   * @param body {
                  "bic": "string" (SWIFT/BIC code)
                }
   */
  postVerifyBIC(body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.post(`${this.API_URL}${API_ARTISTS}${API_VERIFY}/bic`, JSON.stringify(body), <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  /**
   * Verifies the VAT ID.
   * @param body {
                    "country": 0 (Id of country (got from /countries service)),
                    "vatID": "string" (Vat ID)
                  }
   */
  postVerifyVAT(body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.post(`${this.API_URL}${API_ARTISTS}${API_VERIFY}/vatId`, JSON.stringify(body), <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  getPromotionByCode(code) {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.get(`${this.API_URL}${API_PROMOTIONS}/${code}`, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  redeemCode(code, currencyId) {
    const id = JSON.parse(CookiesService.getItem(USER_INFO)).id;
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      this.http.post(`${this.API_URL}${API_USER}/${id}/promotions/${code}?currencyId=${currencyId}`, {}, <any>(httpOptions))
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  setPaypalPaymentInfo(body: any): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
        })
      };
      this.http.post(`${this.API_URL}${API_USER}/paymentInfo/paypal`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  setPaypalUserPaymentInfo(body: any, userId): Observable<any> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };
      this.http.post(`${this.API_URL}${API_USER}/${userId}/account/paymentInfo/paypal`, JSON.stringify(body), httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  confirmPaypal(subsId) {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
        })
      };
      this.http.post(`${this.API_URL}${API_USER}/paymentInfo/paypal/confirmation/${subsId}`, {}, httpOptions)
        .subscribe((response: any) => {
          observer.next(response)
        }, (err) => {
          observer.error(err)
        })
    })
  }

  deleteUser(body: any): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN),
        'Accept-Language': 'en',
        'Content-Type': 'application/json',
      }),
      params: new HttpParams({})
    };

    const httpOpt = httpOptions;
    httpOpt['body'] = JSON.stringify(body);

    return this.http
      .delete(`${this.API_URL}/users/me`,
        httpOpt)
      .toPromise();
  }

  async payment3DsInfo(body: any) {
    const token = CookiesService.getItem(USER_TOKEN);
    const id = JSON.parse(CookiesService.getItem(USER_INFO)).id;
    let results;
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      results = await this.http.post(`${this.API_URL}${API_USER}/${id}/account/paymentInfo/card`, body, httpOptions).toPromise();
      return results;
    } catch (err) {
      console.log('Error creating user: ', err);
      return err;
    }
  }

  async sendPayment3DsInfo(body: any, orderId) {
    const token = CookiesService.getItem(USER_TOKEN);
    const id = JSON.parse(CookiesService.getItem(USER_INFO)).id;
    let results;
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      results = await this.http.post(`${this.API_URL}${API_USER}/paymentInfo/card/confirmation/${orderId}`, body, httpOptions).toPromise();
      return results;
    } catch (err) {
      console.log('Error creating user: ', err);
      return err;
    }
  }

  async updatePlanPayment3DsInfo(body: any) {
    const token = CookiesService.getItem(USER_TOKEN);
    const id = JSON.parse(CookiesService.getItem(USER_INFO)).id;
    let results;
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      results = await this.http.post(`${this.API_URL}${API_USER}/${id}/account/paymentInfo/card/updatePlan`, body, httpOptions).toPromise();
      return results;
    } catch (err) {
      console.log('Error updating user: ', err);
      return err;
    }
  }
}
